
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";
import VueSelect from "vue-select";
import Eye from "vue-material-design-icons/Eye.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import PrintIcon from "vue-material-design-icons/Printer.vue";
import { SistemaMixin } from "@/modules/Application";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-cliente-creditos",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    FilterFields,
    VueSelect,
    Eye,
    Pencil,
    PrintIcon,
  },
  data() {
    return {
      fields: [
        {
          label: "Cliente",
          field: "cliente",
          slot: true,
          sortable: false,
          width: "40%",
        },
        {
          label: "Saldo",
          field: "saldo",
          slot: true,
          sortable: true,
          width: "20%",
        },
        {
          label: "Atualizado em",
          field: "updated_at",
          slot: true,
          sortable: false,
          width: "20%",
        },
        {
          label: "Ações",
          field: "actions",
          slot: true,
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
          width: "20%",
        },
      ],
      extratoFields: [
        { key: "created_at", label: "Data" },
        { key: "tipo", label: "Tipo" },
        { key: "origem", label: "Origem" },
        { key: "valor", label: "Valor" },
        { key: "descricao", label: "Descrição" },
        { key: "codigo_voucher", label: "Voucher" },
        { key: "status_voucher", label: "Status" },
        { key: "actions", label: "Ações" },
      ],
      clientes: [],
      clienteSelecionado: null,
      saldoAtual: 0,
      ajuste: {
        saldo: 0,
        descricao: "",
      },
      extrato: [],
      extratoCliente: null,
      extratoSaldoCliente: 0,
      extratoVouchersDisponiveis: [],
      ajusteVouchersDisponiveis: [],
      ajusteVoucherSelecionado: null,
      clienteSearchTimer: null,
    };
  },
  computed: {
    valorAumentoAjuste() {
      const novoSaldo = Number(this.ajuste.saldo) || 0;
      const saldoAnterior = Number(this.saldoAtual) || 0;

      return this.roundTo2Digits(Math.max(novoSaldo - saldoAnterior, 0));
    },
    valorReducaoAjuste() {
      const novoSaldo = Number(this.ajuste.saldo) || 0;
      const saldoAnterior = Number(this.saldoAtual) || 0;

      return this.roundTo2Digits(Math.max(saldoAnterior - novoSaldo, 0));
    },
    valorTrocoAjuste() {
      const saldoVoucher = Number(this.ajusteVoucherSelecionado?.saldo) || 0;

      return this.roundTo2Digits(Math.max(saldoVoucher - this.valorReducaoAjuste, 0));
    },
    vouchersSuficientesAjuste() {
      return this.ajusteVouchersDisponiveis.filter((voucher) => {
        return Number(voucher.saldo) >= this.valorReducaoAjuste;
      });
    },
  },
  methods: {
    roundTo2Digits(value, decPlaces = 2) {
      return Math.round(value * Math.pow(10, decPlaces)) / Math.pow(10, decPlaces);
    },
    novoAjuste() {
      this.clienteSelecionado = null;
      this.saldoAtual = 0;
      this.ajuste = {
        saldo: 0,
        descricao: "",
      };
      this.ajusteVouchersDisponiveis = [];
      this.ajusteVoucherSelecionado = null;
      this.$bvModal.show("modal-ajuste-credito");
    },
    async abrirAjuste(row) {
      this.clienteSelecionado = row.pessoa;
      this.saldoAtual = Number(row.saldo) || 0;
      this.ajuste = {
        saldo: Number(row.saldo) || 0,
        descricao: "",
      };
      this.ajusteVoucherSelecionado = null;
      await this.carregarVouchersAjuste(row.id_pessoa);
      this.$bvModal.show("modal-ajuste-credito");
    },
    async setCliente(cliente) {
      if (!cliente) return;
      this.clienteSelecionado = cliente;
      const [saldoResponse, vouchersResponse] = await Promise.all([
        this.$http.post("/financeiro/cliente-creditos/saldo", {
          id_pessoa: cliente.id_pessoa,
        }),
        this.$http.post("/financeiro/cliente-creditos/vouchers-disponiveis", {
          id_pessoa: cliente.id_pessoa,
        }),
      ]);
      this.saldoAtual = Number(saldoResponse.data.saldo) || 0;
      this.ajuste.saldo = this.saldoAtual;
      this.ajusteVouchersDisponiveis = vouchersResponse.data ?? [];
      this.ajusteVoucherSelecionado = null;
    },
    async carregarVouchersAjuste(idPessoa) {
      if (!idPessoa) {
        this.ajusteVouchersDisponiveis = [];
        return;
      }

      const { data } = await this.$http.post(
        "/financeiro/cliente-creditos/vouchers-disponiveis",
        {
          id_pessoa: idPessoa,
        }
      );

      this.ajusteVouchersDisponiveis = data ?? [];
    },
    onSearchCliente(search, loading) {
      loading(true);
      if (this.clienteSearchTimer) clearTimeout(this.clienteSearchTimer);
      this.clienteSearchTimer = setTimeout(async () => {
        if (!search || search.length < 2) {
          this.clientes = [];
          loading(false);
          return;
        }
        this.clientes = await this.getClientes(search);
        loading(false);
      }, 350);
    },
    salvarAjuste() {
      if (!this.clienteSelecionado?.id_pessoa) {
        this.$toast.warning("Selecione o cliente.");
        return;
      }

      if (Number(this.ajuste.saldo) < 0) {
        this.$toast.warning("O saldo não pode ser negativo.");
        return;
      }

      if (this.valorReducaoAjuste > 0) {
        if (!this.ajusteVoucherSelecionado?.id) {
          this.$toast.warning("Selecione o voucher que será consumido.");
          return;
        }

        if (Number(this.ajusteVoucherSelecionado.saldo) < this.valorReducaoAjuste) {
          this.$toast.warning("O voucher selecionado não cobre este ajuste.");
          return;
        }
      }

      this.getRequestAdmin(async () => {
        await this.executarAjuste();
      });
    },
    async executarAjuste() {
      this.addLoadingToButton("salvar-ajuste-credito");
      try {
        const novoSaldo = Number(this.ajuste.saldo) || 0;
        const saldoAnterior = Number(this.saldoAtual) || 0;
        const valorVoucher = this.roundTo2Digits(
          Math.max(novoSaldo - saldoAnterior, 0)
        );

        const { data } = await this.$http.post(
          "/financeiro/cliente-creditos/ajustar-saldo",
          {
            id_pessoa: this.clienteSelecionado.id_pessoa,
            saldo: novoSaldo,
            descricao: this.ajuste.descricao,
            saldo_anterior: saldoAnterior,
            gerar_voucher: valorVoucher > 0,
            valor_voucher: valorVoucher,
            id_movimento_voucher: this.ajusteVoucherSelecionado?.id,
            codigo_voucher: this.ajusteVoucherSelecionado?.codigo_voucher,
            origem: "ajuste_credito",
          }
        );
        this.$toast.success("Crédito ajustado com sucesso.");
        this.imprimirVoucherAjuste(data?.["voucher-url"] || data?.voucher_url);
        this.$bvModal.hide("modal-ajuste-credito");
        this.$refs.clienteCreditos.refresh();
      } catch (error) {
        this.$toast.error(error?.response?.data?.msg ?? "Erro ao ajustar crédito.");
      }
      this.removeLoadingToButton("salvar-ajuste-credito");
    },
    imprimirVoucherAjuste(url) {
      if (!url) return;

      const printVoucher = window.open(url, "_blank");
      if (!printVoucher || printVoucher.closed) {
        this.$swal.fire({
          title: "Voucher gerado",
          text: "A impressão automática foi bloqueada pelo navegador.",
          icon: "info",
          confirmButtonText: "Abrir voucher",
          confirmButtonColor: "var(--primary-color)",
        }).then(() => {
          window.open(url, "_blank");
        });
        return;
      }

      printVoucher.focus();
      setTimeout(() => {
        printVoucher.print();
      }, 1000);
    },
    async abrirExtrato(row) {
      this.extratoCliente = row.pessoa;
      this.extratoSaldoCliente = Number(row.saldo) || 0;
      const idPessoa = row.id_pessoa;
      const [movimentosResponse, vouchersResponse] = await Promise.all([
        this.$http.post("/financeiro/cliente-creditos/movimentos", {
          id_pessoa: idPessoa,
          per_page: 50,
        }),
        this.$http.post("/financeiro/cliente-creditos/vouchers-disponiveis", {
          id_pessoa: idPessoa,
        }),
      ]);

      this.extrato = movimentosResponse.data.data ?? [];
      this.extratoVouchersDisponiveis = vouchersResponse.data ?? [];
      this.$bvModal.show("modal-extrato-credito");
    },
    codigoVoucherMovimento(item) {
      return (
        item.codigo_voucher ||
        item.dados?.codigo_voucher ||
        item.dados?.codigo_voucher_origem ||
        ""
      );
    },
    voucherDisponivelMovimento(item) {
      const codigoVoucher = this.codigoVoucherMovimento(item);

      return this.extratoVouchersDisponiveis.find((voucher) => {
        return (
          (item.id && Number(voucher.id) === Number(item.id)) ||
          (codigoVoucher && voucher.codigo_voucher === codigoVoucher)
        );
      });
    },
    statusVoucher(item) {
      const codigoVoucher = this.codigoVoucherMovimento(item);

      if (!codigoVoucher) return "-";

      if (item.tipo === "S") return "Uso";

      const voucherDisponivel = this.voucherDisponivelMovimento(item);

      if (!voucherDisponivel) return "Baixado";

      const saldoDisponivel = Number(voucherDisponivel.saldo) || 0;
      const valorOriginal = Number(item.valor) || 0;

      if (saldoDisponivel < valorOriginal) {
        return `Parcial: R$ ${this.numberToReal(saldoDisponivel, 2)}`;
      }

      return "Ativo";
    },
    classeStatusVoucher(item) {
      const status = this.statusVoucher(item);

      if (status === "Ativo") return "label label-inline label-light-success";
      if (status.includes("Parcial")) return "label label-inline label-light-warning";
      if (status === "Baixado") return "label label-inline label-light-danger";
      if (status === "Uso") return "label label-inline label-light-info";

      return "text-muted";
    },
    async imprimirVoucherAtivo(item) {
      try {
        const { data } = await this.$http.post(
          "/financeiro/cliente-creditos/imprimir-voucher",
          {
            id_movimento: item.id,
            codigo_voucher: this.codigoVoucherMovimento(item),
          }
        );
        const voucherUrl = data?.["voucher-url"] || data?.voucher_url;

        if (!voucherUrl) {
          this.$toast.warning("Não foi possível gerar o voucher.");
          return;
        }

        this.imprimirVoucherAjuste(voucherUrl);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ?? "Erro ao imprimir voucher."
        );
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Crédito de Clientes",
      },
    ]);
  },
};
